<div [ngSwitch]="data">
  <ng-container *ngSwitchCase="'Danger'">
    <span class="c-label c-label--d c-label--color--orange">{{ data }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'Error'">
    <span class="c-label c-label--d c-label--color--yellow">{{ data }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'Critical'">
    <span class="c-label c-label--d c-label--color--red">{{ data }}</span>
  </ng-container>
  <ng-container *ngSwitchCase="'Resolved'">
    <span class="c-label c-label--d c-label--color--gray">{{ data }}</span>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <span>{{ data }}</span>
  </ng-container>
</div>
